import { buttonVariants } from './button-variants';

export function Button({
  variant = 'default',
  size = 'default',
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'default' | 'outline' | 'ghost' | 'danger';
  size?: 'default' | 'sm' | 'lg';
}) {
  return (
    <button
      className={`${buttonVariants[variant]} ${buttonVariants.sizes[size]} ${className ?? ''}`}
      {...props}
    />
  );
}
